import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator, ContextChange, ValidationMessage, ValidationMessageType, HttpService, ResponseStatus } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { environment } from 'src/environments/environment';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { TerminalVisitorRegistration } from '../widgets/terminal/visitor-registration.model';

export class VisitorRegistrationWithOnlineBarcodeController extends AbstractStepController {

    private nextProcessStep = 'visitor-registration-send-data-to-backend';

    // Definiert, ob RegistrationCodes in der Yardinstanz existieren müssen.
    private allowUnknownOnlineTerminalRegistrationCodes = false;
    // Definiert das maximale Alter von Onlineterminal qrcodes.
    private maxAgeOnlineBarcodeInHours = null;

    onContextChange(contextChange: ContextChange) {

    }

    onRegisterToDashboardContext() {
      const dashboardConfiguration = this.wizardComponent.currentStep.dashboardConfiguration;
      if (dashboardConfiguration != null) {
		    if(dashboardConfiguration.nextProcessStep != null) {
        	this.nextProcessStep = dashboardConfiguration.nextProcessStep;
      	}
      	if (dashboardConfiguration.maxAgeOnlineBarcodeInHours != null) {
          this.maxAgeOnlineBarcodeInHours = dashboardConfiguration.maxAgeOnlineBarcodeInHours  * 60 * 60 * 1000;
        }
        if(dashboardConfiguration.allowUnknownOnlineTerminalRegistrationCodes != null) {
          this.allowUnknownOnlineTerminalRegistrationCodes = dashboardConfiguration.allowUnknownOnlineTerminalRegistrationCodes === true;
        }
      }

    }

    public scanSuccessHandler() {
      const barcodeScanned = this.dashboardContext.getContextValue('barcodeScanned');
      console.log('scanSuccessHandler', barcodeScanned);
      if (!barcodeScanned.startsWith('tmc-visit://registration?')) {
        const validationMessages = new Array<ValidationMessage>();
        validationMessages.push(ValidationMessage.createWithData(ValidationMessageType.ERROR, 'tmc-yard.widgets.registration-terminal.visitor-scan-registration-qrcode.error.invalid-qrcode'));
        this.dashboardContext.setContextValue('validationMessages', validationMessages);
        this.dashboardContext.setContextValue('responseMessages', validationMessages);
      } else {
        this.processQRCodeContent(barcodeScanned);
      }
    }

    private processQRCodeContent(qrCodeContent: string) {
      const url = new URL(qrCodeContent);
      const registrationDate = Number(url.searchParams.get('registrationDate'));

      if (this.maxAgeOnlineBarcodeInHours != null && registrationDate + this.maxAgeOnlineBarcodeInHours < Date.now()) {
        const validationMessages = new Array<ValidationMessage>();
        validationMessages.push(ValidationMessage.createWithData(ValidationMessageType.ERROR, 'tmc-yard.widgets.registration-terminal.visitor-scan-registration-qrcode.error.invalid-qrcode'));
        this.dashboardContext.setContextValue('validationMessages', validationMessages);
        this.dashboardContext.setContextValue('responseMessages', validationMessages);
        return false;
      } else {
        const lastname = url.searchParams.get('lastname');
        const firstname = url.searchParams.get('firstname');
        const company = url.searchParams.get('company');
        const numberPlate = url.searchParams.get('numberPlate');
        const visitedPerson = url.searchParams.get('visitedPerson');
        const needsAreaAccess = url.searchParams.get('needsAreaAccess');
        const visitorType = url.searchParams.get('visitorType');
        const registrationCode = url.searchParams.get('registrationCode');
        const inviterId = url.searchParams.get('inviterId');

        // Werte aus Onlinebarcode vorbelegen
        this.dashboardContext.setContextValue(TerminalContextConstants.lastname, lastname != null ? lastname : null);
        this.dashboardContext.setContextValue(TerminalContextConstants.firstname,  firstname != null ? firstname : null);
        this.dashboardContext.setContextValue(TerminalContextConstants.company, company != null ? company : null);
        this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, numberPlate != null ? numberPlate : null);
        this.dashboardContext.setContextValue(TerminalContextConstants.visitedPerson, visitedPerson != null ? visitedPerson : null);
        this.dashboardContext.setContextValue('needsAreaAccess', needsAreaAccess != null && needsAreaAccess === 'true');
        this.dashboardContext.setContextValue('entranceBarrierSecuredAreaNeeded', needsAreaAccess != null && needsAreaAccess === 'true');
        this.dashboardContext.setContextValue('visitorType', visitorType);
        this.dashboardContext.setContextValue('inviterId', inviterId);

        // Wenn registration code vorhanden, veruschen die Daten per Code zu laden
        if (registrationCode != null && registrationCode.trim().length > 0) {
          this.dashboardContext.setContextValue('registrationCode', registrationCode);
          this.validateRegistrationCodeAndGetVisitData(registrationCode);
        } else {
          if (this.wizardComponent.dashboardContext)
          this.wizardComponent.next(this.nextProcessStep);
        }
      }
    }

    private validateRegistrationCodeAndGetVisitData(registrationCode: string) {

      const httpService = WizardServiceLocator.injector.get(HttpService);

      this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, true);
      return httpService.postWithContext(environment.registrationVisitorCodeEndpoint, {code: registrationCode})
        .toPromise().then((response: TerminalVisitorRegistration) => {
          this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
          this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
          if (response.status !== ResponseStatus.FAILED) {

            const registration = new TerminalVisitorRegistration(response);

              this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registration.registrationId);
              this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, registration.gcCaseId);

              const numberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);
              if (numberPlate == null || numberPlate.trim().length === 0) {
                this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, registration.numberPlate);
              }
              const lastname = this.dashboardContext.getContextValue(TerminalContextConstants.lastname);
              if (lastname == null || lastname.trim().length === 0) {
                this.dashboardContext.setContextValue(TerminalContextConstants.lastname, registration.name);
              }
              const firstname = this.dashboardContext.getContextValue(TerminalContextConstants.firstname);
              if (firstname == null || firstname.trim().length === 0) {
                this.dashboardContext.setContextValue(TerminalContextConstants.firstname, registration.firstname);
              }
              const company = this.dashboardContext.getContextValue(TerminalContextConstants.company);
              if (company == null || company.trim().length === 0) {
                this.dashboardContext.setContextValue(TerminalContextConstants.company, registration.company);
              }
              const reasonForVisit = this.dashboardContext.getContextValue(TerminalContextConstants.reasonForVisit);
              if ( reasonForVisit == null || reasonForVisit.trim().length === 0) {
                this.dashboardContext.setContextValue(TerminalContextConstants.reasonForVisit, registration.reason);
              }
              const visitedPerson = this.dashboardContext.getContextValue(TerminalContextConstants.visitedPerson);
              if (visitedPerson == null || visitedPerson.trim().length === 0) {
                this.dashboardContext.setContextValue(TerminalContextConstants.visitedPerson, registration.visitedPerson);
              }
              const visitorType = this.dashboardContext.getContextValue('visitorType');
              if (visitorType == null || visitorType.trim().length === 0) {
                this.dashboardContext.setContextValue('visitorType', registration.visitorType);
              }
              const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
              logContainer.addLog('Valid code detected. Register arrival.');
              this.wizardComponent.next('visitor-registration-send-data-to-backend');
          } else if (this.allowUnknownOnlineTerminalRegistrationCodes === false) {
            const validationMessages = new Array<ValidationMessage>();
            for (const responseMessage of response.responseMessages) {
              validationMessages.push(ValidationMessage.createWithData(ValidationMessageType.ERROR, responseMessage.dictionaryKey));
            }
            this.dashboardContext.setContextValue('validationMessages', validationMessages);
            this.dashboardContext.setContextValue('responseMessages', validationMessages);
          }
      }, error => {
          // TODO specify what happens for bad codes
      });
  }

    public handleFlow(): FlowStepHandleResult {
        this.wizardComponent.startInactivityMonitoring();
        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('registration code validation started');

        this.scanSuccessHandler();

        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;
        return result;
    }

    private cancel() {
        const matDialog = WizardServiceLocator.injector.get(MatDialog);
        const dialogData: ConfirmDialogData = {
            titleKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
            messageKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.message',
            confirm: () => {
                this.wizardComponent.stopInactivityMonitoring();
                this.wizardComponent.startProcessFlow(this.wizardComponent.contentIdentifier);
            }
        };
        matDialog.open(ConfirmDialogComponent, {
            data: dialogData
        });
    }

    getControls(): StepControl[] {
      const controls = new Array<StepControl>();

      const previousControl = new StepControl();
      previousControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.previous';
      previousControl.type = StepControlType.BUTTON_STROKED;
      previousControl.iconBeforeCss = 'fa-thin fa-angle-left';
      previousControl.controlAction = () => {
          this.wizardComponent.stopInactivityMonitoring();
          this.wizardComponent.previous();
      };
      controls.push(previousControl);

      let spacer = new StepControl();
      spacer.type = StepControlType.SPACER_GROW;
      controls.push(spacer);

      const cancelControl = new StepControl();
      cancelControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.cancel';
      cancelControl.type = StepControlType.BUTTON_STROKED;
      cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
      cancelControl.controlAction = this.cancel.bind(this);
      controls.push(cancelControl);

      spacer = new StepControl();
      spacer.type = StepControlType.SPACER;
      controls.push(spacer);

      const newRegistrationControl = new StepControl();
      newRegistrationControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.transport-registration-with-code.button.alternative';
      newRegistrationControl.type = StepControlType.BUTTON_STROKED;
      newRegistrationControl.iconAfterCss = 'fa-thin fa-angle-right';
      newRegistrationControl.controlAction = () => {
          this.wizardComponent.stopInactivityMonitoring();
          this.wizardComponent.next('language-selection');
      };
      controls.push(newRegistrationControl);

      return controls;
  }
}
